export default {
  p: { x: 416, y: 155, b: 'ew', d: 100 },
  r: 30,
  s: [
    { x: 400, y: 80, b: 'ew', d: 200 },
    { x: 250, y: 230 },
    { x: 550, y: 200 },
  ],
  b: [
    { x: 400, y: 120, b: 'ew', d: 100 },
    { x: 300, y: 250, b: 'ew', d: 80 },
    { x: 500, y: 220, b: 'ew', d: -80 },
  ],
  g: [
    { x: 600, y: 700 },
    { x: 100, y: 700 },
  ],
  h: [
    { x: 600, y: 100 },
    { x: 200, y: 50 },
  ],
};
